import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1.2rem;

  h2 {
    font-size: 1.9rem;
    margin: 0;
  }

  form {
    display: grid;
    gap: 1rem;
    width: 100%;

    input,
    textarea {
      width: 100%;
      padding: 1.1rem 1.4rem;
      border-radius: 12px;
      outline: none;
      border: 1px solid var(--border);
      background: var(--pill-bg);
      color: var(--text);
      font-weight: 600;

      &::placeholder {
        color: var(--muted);
      }
    }

    textarea {
      min-height: 16rem;
      resize: vertical;
    }

    button {
      padding: 1.1rem 2.4rem;
      justify-self: flex-start;
    }
  }

  @media (max-width: 640px) {
    h2 {
      font-size: 1.7rem;
    }
  }
`

export const ContainerSucces = styled.div`
  margin-top: 2rem;
  text-align: center;
  display: grid;
  gap: 0.8rem;

  button {
    border-radius: 0.8rem;
    padding: 1rem 1.4rem;
    text-transform: uppercase;
    text-align: center;
    color: var(--text);
  }
`
